import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Divider,
  IconButton,
  CircularProgress,
  Chip,
  Box,
  Stack,
  Link,
} from "@mui/material";
import { useTheme, alpha } from "@mui/material/styles";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import axios from "axios.js";

const SMSAccount = () => {
  const theme = useTheme();

  const [smsInfo, setSMSInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [IsValidValues, setIsValidValues] = useState(true);

  const [showPassword, setShowPassword] = useState({
    Password: false,
    DLTPassword: false,
  });

    const fetchSMSAccountInfo = async () => {
        try
        {

            const response = await axios.get("/sms-account-info");
            setSMSInfo(response.data.SMSAccountDetails[0]);

            setIsValidValues(response.data.IsValidValues);
        }
        catch (error)
        {
            console.error("Error fetching SMS Account data", error);
        }
        finally
        {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchSMSAccountInfo();
    }, []);

    const togglePassword = (field) => {
        setShowPassword((prev) => ({
            ...prev,
            [field]: !prev[field],
        }));
    };

  const renderField = (label, value, isPassword = false, fieldName = "") => (
    <>
      <Grid container spacing={1} sx={{ py: 1.5 }} alignItems="center">
        <Grid item xs={12} md={4}>
          <Typography variant="body2" fontWeight={600}>{label}</Typography>
        </Grid>

        <Grid item xs={12} md={8}>
          {isPassword ? (
            <Stack direction="row" alignItems="center" spacing={0.5}>
              <Typography
                component="span"
                variant="body2"
                color="text.secondary"
                sx={{
                  fontFamily: showPassword[fieldName] ? "inherit" : "monospace",
                  letterSpacing: showPassword[fieldName] ? "normal" : 2
                }}
              >
                {showPassword[fieldName] ? value : "••••••••"}
              </Typography>

              <IconButton
                size="small"
                onClick={() => togglePassword(fieldName)}
                sx={{ color: "text.secondary", "&:hover": { color: "primary.main" } }}
              >
                {showPassword[fieldName] ? (
                  <VisibilityOff fontSize="small" />
                ) : (
                  <Visibility fontSize="small" />
                )}
              </IconButton>
            </Stack>
          ) : (
            <Typography variant="body2" color="text.secondary">
              {value || "-"}
            </Typography>
          )}
        </Grid>
      </Grid>
      <Divider sx={{ opacity: 0.6 }} />
    </>
  );

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: 300 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: 2,
        border: `1px solid ${theme.palette.divider}`,
        borderTop: `3px solid ${theme.palette.primary.main}`,
        maxWidth: 900,
        mx: "auto",
        mt: 4,
      }}
    >
      <CardContent sx={{ p: 3 }}>
        <Typography variant="h6" fontWeight={700}>
          SMS Account Information
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Current SMS gateway and DLT registration settings.
        </Typography>

        <Divider sx={{ mb: 1 }} />
            {
                IsValidValues && (
                <>
                    {renderField("Username", smsInfo?.SMSAccountUsername)}

                    {renderField(
                    "Password",
                    smsInfo?.SMSPassword,
                    true,
                    "Password"
                    )}



                    <Grid container spacing={1} sx={{ py: 1.5 }} alignItems="center">
                        <Grid item xs={12} md={4}>
                            <Typography variant="body2" fontWeight={600}>
                            Is Unicode Conversion Required
                            </Typography>
                        </Grid>

                        <Grid item xs={12} md={8}>
                            <Chip
                                size="small"
                                label={smsInfo?.IsUnicodeConversionRequired === 1 ? "Yes" : "No"}
                                color={smsInfo?.IsUnicodeConversionRequired === 1 ? "success" : "error"}
                            />
                        </Grid>
                    </Grid>
                    <Divider sx={{ opacity: 0.6 }} />

                    <Grid container spacing={1} sx={{ py: 1.5 }} alignItems="center">
                        <Grid item xs={12} md={4}>
                            <Typography variant="body2" fontWeight={600}>
                            DLT Registration Company
                            </Typography>
                        </Grid>

                        <Grid item xs={12} md={8}>
                            <Chip
                            size="small"
                            label={smsInfo?.DLTRegistrationCompany}
                            color="primary"
                            variant="outlined"
                            />
                        </Grid>
                    </Grid>
                    <Divider sx={{ opacity: 0.6 }} />

                    {renderField("Marathi SMS URL", smsInfo?.MarathiSMSURL)}

                    {renderField("English SMS URL", smsInfo?.EnglishSMSURL)}

                    <Grid container spacing={2} sx={{ py: 1.5 }} alignItems="center">
                        <Grid item xs={12} md={4}>
                            <Typography variant="body2" fontWeight={600}>
                                DLT Login URL
                            </Typography>
                        </Grid>

                        <Grid item xs={12} md={8}>
                            <Link
                                href={smsInfo?.DLTRegistrationURL}
                                target="_blank"
                                rel="noopener noreferrer"
                                variant="body2"
                                underline="hover"
                                sx={{ wordBreak: "break-all" }}
                            >
                                {smsInfo?.DLTRegistrationURL}
                            </Link>
                        </Grid>
                    </Grid>
                    <Divider sx={{ opacity: 0.6 }} />

                    {renderField("DLT Username", smsInfo?.DLTUsername)}

                    {renderField(
                    "DLT Password",
                    smsInfo?.DLTPassword,
                    true,
                    "DLTPassword"
                    )}

                    {renderField(
                    "Registered Mobile Number",
                    smsInfo?.DLTMobileNumber
                    )}

                    {renderField(
                    "Registered Email",
                    smsInfo?.DLTEmail
                    )}



                    {renderField(
                    "Created At",
                    new Date(smsInfo?.created_at).toLocaleString()
                    )}
                </>)
            }

            { !IsValidValues && (
                <Stack
                    direction="row"
                    spacing={1.5}
                    alignItems="flex-start"
                    sx={{
                        mt: 2,
                        p: 2,
                        borderRadius: 1.5,
                        backgroundColor: alpha(theme.palette.warning.main, 0.08),
                        border: `1px solid ${alpha(theme.palette.warning.main, 0.3)}`
                    }}
                >
                    <InfoOutlinedIcon color="warning" fontSize="small" sx={{ mt: 0.25 }} />
                    <Typography variant="body2" color="text.primary">
                        SMS account yet to setup. Please contact your administrator.
                    </Typography>
                </Stack>
            )}

      </CardContent>
    </Card>
  );
};

export default SMSAccount;
